import * as React from 'react';
import { useABTestingConfig } from '@packages/shared';

import { LinkTarget, SmartLink } from '../../SmartLink';
import { dyImageSrcToCdnImageSrc } from '../utils/dyImageSrcToCdnImageSrc';
import type { DyImage } from '../types';

interface DYImageBannerProps {
  onClick: VoidFunction;
  data: {
    target: LinkTarget;
    linkUrl: string;
    image: DyImage;
  };
}

export const DYImageBanner: React.FC<DYImageBannerProps> = ({ data }) => {
  const { target, linkUrl, image } = data;
  const { IMAGE_CDN_PROVIDER } = useABTestingConfig() || {};

  return (
    <SmartLink target={target} linkUrl={linkUrl}>
      <img
        width={image.width}
        height={image.height}
        alt="moebel.de banner"
        src={dyImageSrcToCdnImageSrc(image, IMAGE_CDN_PROVIDER)}
      />
    </SmartLink>
  );
};
